<template>
    <div class="media-artwork-container text-center text-md-center" :class="[shortlistClass]">
        <component :is="linkToDetail?'a':'div'" :href="deepLink"  class="media-detail-artwork color-white" :class="[containerHoverClass]">
            <audio v-if="showControls" :ref="audioId" preload="none" v-on:ended="audioEnded">
                <source :src="sampleUrl"/>
            </audio>

            <div :class="imgMediaDetailArtworkClass">
                <img :src="artworkSrc">
            </div>

            <span class="media-detail-type-badge-container top-left">
                <span v-if="showTypeBadge" class="badge badge-light media-detail-type-badge">
                    <span class="upper"> {{ item.type }} </span>
                </span>

                <span v-if="showPremiumBadge || showTypeBadge" class="badge badge-light media-detail-type-badge premium" :class="[mediaTierClass]">
                    <span v-if="item.tier >= 4"><i class="fas fa-crown upper"></i> PREMIUM </span>
                    <span v-else-if="item.tier >= 2"><i class="fas fa-link upper"></i> FREE W/ LINKING </span>
                    <span v-else><i class="fas fa-check-circle upper"></i> FREE </span>
                </span>
            </span>

            <div v-if="showCastButton">
                <a class="media-detail-cast" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fab fa-chromecast"></i></a>
                <div class="dropdown-menu">
                    <a class="dropdown-item" :href="quickLinkUrl('alexa')" target="_blank" :title="quickLinkTitle('alexa')">{{ quickLinkTitle('alexa') }}</a>
                </div>
            </div>

            <span v-if="showTitle" class="media-detail-title">{{item.name}}</span>

            <a v-if="showControls" class="media-detail-playback bottom-right" v-on:click="togglePlayback"><i class="fas" :class="[buttonIconClass]"></i></a>
        </component>
    </div>
</template>

<script>
    import { EventBus } from '../event-bus.js';
    export default {
        props: ['emitName','emitPool','isShortlist','item','itemKey','platform','showPremiumBadge','showTypeBadge','showCastButton','showTitle','showControls','hoverEffect','linkToDetail'],
        data () {
            return {
                "is_playing": false
            }
        },
        methods: {
            quickLinkTitle: function(platformOverride){
                platformOverride = platformOverride || this.platform;
                switch(platformOverride){
                    case "aog":
                        return "Cast to Google Assistant";
                    case "alexa":
                        if(this.item.type == "ALARM"){
                            return "Enable this alarm tone on Alexa";
                        }else{
                            return "Play on Alexa";
                        }
                    default:
                        return "";
                }
            },
            quickLinkUrl: function(platformOverride){
                platformOverride = platformOverride || this.platform;
                switch(platformOverride){
                    case "alexa":
                        if(this.item.type == "ALARM"){
                            return this.item.alexa_alarm_url;
                        }else{
                            // eslint-disable-next-line
                            return this.$root.quick_launch.alexa + "&sound=" + encodeURIComponent(this.item.title.replace(/['!"#$%&\\'()\*+,\-\.\/:;<=>?@\[\\\]\^_`{|}~']/g,"").replace(/\s{2,}/g," ").toLowerCase());
                        }
                    default:
                        return "";
                }
            },
            "stopAudio": function(){
                this.is_playing = false;
                this.$refs[this.audioId].pause();
                this.$root.removePlaying(this.emitPool, this.itemKey);
            },
            "startAudio": function(){
                this.is_playing = true;
                this.$refs[this.audioId].currentTime = 0;
                this.$refs[this.audioId].play();
                this.$root.addPlaying(this.emitPool, this.itemKey);

                // if more than 2 sounds are playing, force the first to stop
                if(this.$root.now_playing[this.emitPool].length > 1){
                    EventBus.$emit(this.emitName, this.$root.now_playing[this.emitPool][0]);
                }
            },
            "audioEnded": function(){
                this.stopAudio();
            },
            "togglePlayback": function(){
                if(this.is_playing){
                    // stop it
                    this.stopAudio();
                }else{
                    // start it
                    this.startAudio();
                }
            }
        },
        computed: {
            "artworkSrc": function(){
                var url = `https://cdn.sleepjar.com/sleepsounds/images/artwork/${(this.item.type).toLowerCase()}`;
                if(this.item.type != "SOUND"){
                    url += `/cover/svg/${this.itemKey}.svg`;
                }else{
                    url += `/icon/white/svg/${this.itemKey}.svg`;
                }
                return url;
            },
            "containerHoverClass": function(){
                return {
                    "media-artwork-container-hover": this.hoverEffect == true
                };
            },
            "imgMediaDetailArtworkClass": function(){
                return {
                    "img-media-detail-artwork-icon": this.item.type == "SOUND",
                    "img-media-detail-artwork-cover": this.item.type != "SOUND"
                };
            },
            audioId: function(){
                return "audio" + this.itemKey;
            },
            deepLink: function(){
                var url = "";
                switch(this.item.type){
                    case "STORY":
                        url += "/stories";
                        break;
                    case "MEDITATION":
                        url += "/meditations";
                        break;
                    case "JOURNEY":
                        url += "/journeys";
                        break;
                    default:
                        url += "/sounds";
                }
                url += `/${this.itemKey}`;

                return url;
            },
            sampleUrl: function(){
                var filename = this.itemKey;
                if(this.item.variants.length){
                    filename = this.item.variants.find(function(variant){
                        return variant.is_default;
                    }).key;
                }
                return "/audio/sd/sample/" + filename + ".mp3";
            },
            buttonIconClass: function(){
                return {
                    "fa-play": !this.is_playing,
                    "fa-stop": this.is_playing
                };
            },
            colorClass: function(){
                return {
                    "color-white": this.item.type != "SOUND",
                    "color-black": this.item.type == "SOUND"
                };
            },
            buttonText: function(){
                return this.is_playing ? "Stop" : "Preview";
            },
            shortlistClass: function(){
                return {
                    "story-container": this.isShortlist ? true : false
                }
            },
            mediaTierClass: function(){
                return {
                    "premium": this.item.tier > 3 ? true : false,
                    "free": this.item.tier <= 3 ? true : false
                }
            },
            "displayCastButton": function(){
                return this.showCastButton && this.item.type == "SOUND";
            }
        }
    }
</script>
